<template>
    <div>
        <div class="auth-layout__title">
            <common-page-header
                :heading="title"
                :size="isTabletSmall ? 'larger' : 'huge'"
                contentSpacing="small"
                :isCenter="true"
            >
                <template #content>
                    <slot name="subtitle"></slot>
                </template>
            </common-page-header>
        </div>

        <common-message v-if="message?.text" :type="message.type">
            {{ $t(message.text) }}
            <common-button
                v-if="message.buttonLabel && message.buttonOnClickFunction"
                type="link"
                :isSubmittable="false"
                :label="$t(message.buttonLabel)"
                @click="message.buttonOnClickFunction"
            ></common-button>
        </common-message>

        <main>
            <common-content-wrapper class="auth-layout__content" width="large">
                <div class="auth-layout__content--left">
                    <slot name="left-side"></slot>
                </div>

                <div v-if="hasRightSide" class="auth-layout__content--divider"></div>
                <common-divider v-if="hasRightSide">
                    <span class="auth-layout__content--divider-text">
                        {{ $t('layouts.auth.divider.or') }}
                    </span>
                </common-divider>

                <div v-if="hasRightSide" class="auth-layout__content--right">
                    <slot name="right-side"></slot>
                </div>
            </common-content-wrapper>
        </main>
    </div>
</template>

<script>
    import WindowResizeMixin from 'mixins/WindowResizeMixin'
    export default {
        mixins: [WindowResizeMixin],
        props: {
            title: { type: String, required: true },
            message: { type: Object, default: null },
            hasRightSide: { type: Boolean, default: true },
        },
    }
</script>
